module.exports = __webpack_public_path__ + "img/facebook.0904b5b4.svg";